import { render, staticRenderFns } from "./service-center-nav.vue?vue&type=template&id=34072302&scoped=true&"
import script from "./service-center-nav.vue?vue&type=script&lang=js&"
export * from "./service-center-nav.vue?vue&type=script&lang=js&"
import style0 from "./service-center-nav.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./service-center-nav.vue?vue&type=style&index=1&id=34072302&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "34072302",
  null
  
)

export default component.exports